/* @flow */
import Audio from 'components/Audio.jsx';
import FileImagePreview from 'groups/components/FileImagePreview.jsx';
import FilePreview from 'groups/components/FilePreview.jsx';
import Image from 'components/Image.jsx';
import React from 'react';
import Video from 'components/Video.jsx';

import type { FilePreviewerProps } from 'groups/components/FilePreview.jsx';

const FileAudioPreview = ({file}: FilePreviewerProps) => ( // eslint-disable-line object-curly-spacing
  <Audio
    src={file.getUrls().cdn}
    file={file}
    key={file.id}
  />
);

const FileVideoPreview = ({file}: FilePreviewerProps) => ( // eslint-disable-line object-curly-spacing
  <Video
    src={file.getUrls().cdn}
    file={file}
    key={file.id}
  />
);

export class FileContentPreview extends React.Component {
  props: FilePreviewerProps;

  state = {
    mounted: false,
  };

  componentDidMount() {
    // We want to set this state after mount so the first render matches the server's.
    /* eslint-disable react/no-did-mount-set-state */
    this.setState({ mounted: true });
  }

  render() {
    const { file } = this.props;
    const contentType = file.getContentType();

    if (Image.isSupportedType(contentType)) {
      return <FileImagePreview file={file} />;
    }

    // These previews render differently in browser and Node. So React can
    // match client to server DOMs we have to wait until mounted to change it.
    // TODO continue refactoring to move this concern into <FileAudioPreview> and <FileVideoPreview>
    if (this.state.mounted) {
      if (Audio.isSupportedType(contentType)) {
        return <FileAudioPreview file={file} />;
      } else if (Video.isSupportedType(contentType)) {
        return <FileVideoPreview file={file} />;
      }
    }

    return <FilePreview file={file} key={file.id} />;
  }
}

export default FileContentPreview;



// WEBPACK FOOTER //
// ./src/groups/components/FileContentPreview.jsx